import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

// Passwords screens
import PasswordsDashboardScreen from '../../screens/tasks/passwords/PasswordsDashboardScreen';
import PasswordsIntroScreen from '../../screens/tasks/passwords/PasswordsIntroScreen';
import PasswordsInputScreen from '../../screens/tasks/passwords/PasswordsInputScreen';
import PasswordsDataScreen from '../../screens/tasks/passwords/PasswordsDataScreen';
import PasswordsLockUnlockScreen from '../../screens/tasks/passwords/PasswordsLockUnlockScreen';
import PasswordsLockedScreen from '../../screens/tasks/passwords/PasswordsLockedScreen';
import PasswordsUnlockedScreen from '../../screens/tasks/passwords/PasswordsUnlockedScreen';

const Stack = createNativeStackNavigator();

const PasswordsStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      {/* Main Passwords Screens */}
      <Stack.Screen name="PasswordsDashboard" component={PasswordsDashboardScreen} />
      <Stack.Screen name="PasswordsDashboardScreen" component={PasswordsDashboardScreen} />
      <Stack.Screen name="PasswordsIntro" component={PasswordsIntroScreen} />
      <Stack.Screen name="PasswordsInput" component={PasswordsInputScreen} />
      <Stack.Screen name="PasswordsInputScreen" component={PasswordsInputScreen} />
      <Stack.Screen name="PasswordsData" component={PasswordsDataScreen} />
      <Stack.Screen name="PasswordsDataScreen" component={PasswordsDataScreen} />
      <Stack.Screen name="PasswordsLockUnlock" component={PasswordsLockUnlockScreen} />
      <Stack.Screen name="PasswordsLocked" component={PasswordsLockedScreen} />
      <Stack.Screen name="PasswordsUnlocked" component={PasswordsUnlockedScreen} />
    </Stack.Navigator>
  );
};

export default PasswordsStackNavigator;